import reduxFetch from 'react-redux-fetch';
import { INVITATION_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: INVITATION_RESOURCE,
      method: 'get',
      request: token => ({ url: apiRoutes.invitation(token) }),
    },
  ])(ComposedComponent);
